import { PatientList } from 'components';
import { useTranslation } from 'react-i18next';
import { useRoomRightSidebar } from 'hooks';
import { MenuItem } from '../MenuItem';
import { isHipaaLink } from '../../../../config/productProfile';

type ClientQueueMenuProps = {
  className?: string;
};

export function ClientQueueMenu({ className }: ClientQueueMenuProps): JSX.Element {
  const { t } = useTranslation('providerRoom');
  const { hideSidebar } = useRoomRightSidebar();

  return (
    <>
      <MenuItem className={className} title={isHipaaLink ? t('clientQueue') : t('waitingRoom')}>
        <PatientList isCallStarted onAfterOpenChat={hideSidebar} />
      </MenuItem>
    </>
  );
}
